export default __webpack_public_path__ + "static/media/profileAvatar.2e039c6c.svg";